import { useEffect, useState } from "react";
import http from "../../http";
import { Madeira } from "../../../interfaces/madeira.interface";
import CardMadeira from "../../Cards/CardMadeira";
import FormMadeira from "../../Form/FormMadeira";
import styles from './SectionMadeiras.module.scss';

export default function SectionMadeiras() {
    const [madeiras, setMadeiras] = useState<Madeira[]>([]);
    const [click, setClick] = useState<boolean>(false);
    const [madeiraSelecionada, setMadeiraSelecionada] = useState<Madeira>({});

    const iniciaEstoque = async () => {
        try {
            const response = await http.get('madeiras');
            setMadeiras(response.data);
        } catch (error) {
            console.error("Erro ao carregar o estoque:", error);
        }
    }

    const selecionaMadeira = (dados: Madeira) => {
        setMadeiraSelecionada(dados);
        setClick(!click);
    }

    const atualizaMadeira = async (dados: Madeira) => {
        const { id, createdAt, updatedAt, deletedAt, ...allowedData } = dados;

        allowedData.COD = Number(allowedData.COD);
        allowedData.valor = Number(allowedData.valor);

        try {
            await http.put(`madeiras/${dados.id}`, allowedData);
            setClick(false);
            await iniciaEstoque();
            setClick(!click);
        } catch (error) {
            console.error("Erro ao atualizar a madeira:", error);
        }
    }

    const excluir = async (dados: Madeira) => {
        try {
            await http.delete(`madeiras/${dados.id}`);
            await iniciaEstoque();
        } catch (error) {
            console.error("Erro ao excluir a madeira:", error);
        }
    }

    useEffect(() => {
        iniciaEstoque();
    }, []);

    // Ordena as madeiras pela data da mais recente para a mais antiga
    // Ordena as madeiras pelo COD em ordem crescente
    const madeirasOrdenadas = [...madeiras].sort((a, b) => {
        const codA = a.COD !== undefined ? a.COD : -Infinity;
        const codB = b.COD !== undefined ? b.COD : -Infinity;
        return codA - codB;
    });



    return (
        <section className={styles.container}>


            <h1>Madeira em Estoque</h1>

            {click &&
                <FormMadeira
                    initialData={madeiraSelecionada}
                    onSubmit={atualizaMadeira}
                />
            }

            {!click &&
                <div className={styles.containerMadeiras}>
                    {madeirasOrdenadas.map((item) => (
                        <CardMadeira
                            key={item.id}
                            madeira={item}
                            onClick={selecionaMadeira}
                            excluir={excluir}
                        />
                    ))}
                </div>
            }
        </section>
    );
}
